import * as React from "react";
import styled from "@mui/material/styles/styled";
import { Fab, Theme } from "@mui/material";
import { makeStyles, createStyles } from "@mui/styles";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import AddIcon from "@mui/icons-material/Add";
import { bottomNavigationZIndex } from "fe-common/ui/stacking";
import { useRouteHelper } from "../useRouteHelper";
import { AgentRoute } from "../util/agentRoutes";
import { ACTION, CATEGORY, evt } from "fe-common/analytics/analytics";
import { MobileView } from "../../../util/aKaunGeneralUtil";
import { useScreenSize } from "../util/useScreenSize";
import { useDiagnosticNavigation } from "../useDiagnosticNavigation";

//region [[ Styles ]]

const ImproveDiagnosisButtonView = styled("div")(
  ({ theme }: { theme?: Theme }) => ({
    [theme.breakpoints.down(MobileView)]: {
      position: "fixed",
      bottom: "100px",
      left: "50%",
      transform: "translate(-50%, 0)",
      zIndex: bottomNavigationZIndex,
    },
  }),
);

const AddIconStyled = styled(AddIcon)({
  color: KahunColorMap.Secondary,
});

const AddIconContainer = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "white",
  color: KahunColorMap.Secondary,
  marginRight: "10px",
  height: "41px",
  width: "41px",
  marginLeft: "-8px",
  borderRadius: "50%",
  [theme.breakpoints.up(MobileView)]: {
    height: "30px",
    width: "30px",
  },
}));

const FabStyled = styled(Fab)(({ theme }) => ({
  color: "white",
  backgroundColor: KahunColorMap.Secondary,
  "&:hover": {
    backgroundColor: KahunColorMap.Secondary,
  },
  textTransform: "none",
  fontSize: "15px",
  height: "55px",
  fontWeight: 500,
  width: "auto",
  whiteSpace: "nowrap",
  [theme.breakpoints.up(MobileView)]: {
    boxShadow: "none",
    height: "44px",
  },
}));

const ButtonText = styled("span")({});
//endregion [[ Styles ]]

const useStyles = makeStyles((theme?: Theme) =>
  createStyles({
    root: {
      "& > *": {
        margin: theme.spacing(1),
        marginRight: "10px",
      },
    },
    extendedIcon: {
      color: KahunColorMap.Secondary,
    },
  }),
);

//region [[ Props ]]
export interface ImproveDiagnosisButtonProps {
  className?: string;
}
//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ImproveDiagnosisButton = (props: ImproveDiagnosisButtonProps) => {
  const classes = useStyles();

  const { navigateTo } = useRouteHelper();
  const { isMobile } = useScreenSize();
  const {
    setImproveDiagnosisPopupOpen: openImproveDiagnosis,
  } = useDiagnosticNavigation();

  const handleOpenImproveDiagnosis = () => {
    evt({
      category: CATEGORY.IMPROVE_DIAGNOSIS,
      action: ACTION.OPEN_IMPROVE_DIAGNOSIS,
    });

    if (isMobile) {
      navigateTo({ route: AgentRoute.HistoryAndPhysical });
    } else {
      openImproveDiagnosis(true);
    }
  };

  return (
    <ImproveDiagnosisButtonView className={props.className}>
      <FabStyled
        className={"fab-icon"}
        variant="extended"
        onClick={handleOpenImproveDiagnosis}
      >
        <AddIconContainer className={"add-icon-container"}>
          <AddIconStyled className={classes.extendedIcon} />
        </AddIconContainer>
        <ButtonText className={"icon-text"}>Improve Suggestions</ButtonText>
      </FabStyled>
    </ImproveDiagnosisButtonView>
  );
};
